import { ElectionState, ElectionStatus, VoteResult, Translatable } from './_generatedTypes.g';

export const canVote = (election: ElectionState) =>
    election.ElectionStatus === ElectionStatus.Open &&
    election.VoteResult === VoteResult.NotYetVoted &&
    election.UserHasVotingRight;

export const turnoutPercentage = (el: { VoteCount: number, VoterCount: number }) =>
    el.VoterCount == el.VoteCount || el.VoterCount == 0
        ? 0
        : 100 * el.VoteCount / el.VoterCount;

export function suggestCode(name: Translatable, allCodes: string[]) {
    let seed = (name.EN && name.EN.length ? name.EN : name.NL) || '';
    let suggestion = seed.substring(0, Math.min(seed.length, 6)) + '~1';
    let a = 1;
    while (allCodes.find(x => x === suggestion)) {
        suggestion = suggestion.substring(0, Math.min(7, suggestion.length)) + (a++).toString(16);
    }
    return suggestion;
}
